module.exports = __webpack_public_path__ + "static/media/efigenia-vanda.7679fad0.jpeg";